import logo from "../assets/logos/hobo-logo.png";
import { cloudinaryImage } from "../utils/cloudinary";
import { Config } from "../.env.js";

export default function Logo({
  src = logo,
  alt = "Hobo.Video Logo",
  className,
  width,
  height,
}) {
  const isIconLogo =
    typeof src === "string" && /neuriun-logo-(black|white)-icon/i.test(src);
  const intrinsicWidth = width || (isIconLogo ? 1221 : 2040);
  const intrinsicHeight = height || (isIconLogo ? 1122 : 668);

  // This app has no "/" route (the homepage is served outside it), so an
  // in-app <Link to="/"> lands on the 404 page — link to the site root instead.
  return (
    <a href={Config.SITE_URL}>
      <img
        src={cloudinaryImage(src, { width: 320 })}
        alt={alt}
        // width={intrinsicWidth}
        height={intrinsicHeight}
        className={className}
      />
    </a>
  );
}
